import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getPrimaryDefaultActionsData, getRemoveDefaultActionsData } from '../default/getDefaultChickletHoverActions';
import useFetchPaymentLinkCheckoutUrl from './hooks/useFetchPaymentLinkCheckoutUrl';
import useFetchPaymentLinkInternalId from './hooks/useFetchPaymentLinkInternalId';
import { ObjectTypeFromIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const useActions = args => {
  const {
    objectId,
    fromObjectTypeId,
    hasScope
  } = args;
  const canEditPaymentLinks = hasScope('payment-links-write');
  const paymentLinkInternalId = useFetchPaymentLinkInternalId(objectId);
  const paymentLinkEditUrl = paymentLinkInternalId ? `/payment-links/${PortalIdParser.get()}/${paymentLinkInternalId}/items` : null;
  const fromObjectTypeName = ObjectTypeFromIds[fromObjectTypeId];
  const referrerString = fromObjectTypeName ? `?referrer=PAYMENT_LINK_RECORD_${fromObjectTypeName}` : `?referrer=PAYMENT_LINK_RECORD`;
  const checkoutUrl = useFetchPaymentLinkCheckoutUrl(objectId) + referrerString;
  const shouldDisableEdit = !canEditPaymentLinks || !paymentLinkEditUrl;
  const hoverActions = {
    PrimaryAction: {
      copyValue: checkoutUrl,
      disabled: !checkoutUrl,
      label: /*#__PURE__*/_jsx(CopyButton, {
        use: "tertiary",
        size: "xs",
        value: checkoutUrl,
        disabled: !checkoutUrl,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.chicklet.PaymentLinkCopyLinkButton.copyLink"
        })
      }),
      dataTestId: 'payment-link-copy-button'
    },
    SecondaryActions: [getPrimaryDefaultActionsData(args), {
      label: /*#__PURE__*/_jsx(Tooltip, {
        disabled: !shouldDisableEdit,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.chicklet.PaymentLinkEditButton.noEditAccess"
        }),
        children: /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          size: "xs",
          disabled: shouldDisableEdit,
          external: true,
          href: paymentLinkEditUrl || undefined,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cardAssociatedObjects.chicklet.PaymentLinkEditButton.edit"
          })
        })
      })
    }, getRemoveDefaultActionsData(args)]
  };
  return hoverActions;
};
export default useActions;